module.exports = __webpack_public_path__ + "img/apple-icon-120x120.33f95521.png";